/* eslint-disable import/prefer-default-export */

export const setReadIndex = (value) => ({
  type: 'SET_READ_INDEX',
  value,
});

export const setStoredData = (value) => ({
  type: 'SET_STORED_DATA',
  value,
})